import { useState } from "react";
import { paths, quizQuestions } from "../constants";
import { useColors } from "../ColorsContext";

export default function ScreenQuiz({ onResult, onBack }) {
  const C = useColors();
  const [qIndex, setQIndex] = useState(0);
  const [answers, setAnswers] = useState([]);
  const [result, setResult] = useState(null);

  function handleAnswer(pathId) {
    const next = [...answers, pathId];
    if (qIndex < quizQuestions.length - 1) {
      setAnswers(next);
      setQIndex(i => i + 1);
    } else {
      // Tally scores
      const tally = { puzzle: 0, action: 0, gamer: 0 };
      next.forEach(id => tally[id]++);
      const winner = Object.entries(tally).sort((a, b) => b[1] - a[1])[0][0];
      setResult(winner);
    }
  }

  const resultPath = result ? paths.find(p => p.id === result) : null;

  return (
    <div style={{ height: "100%", display: "flex", flexDirection: "column", background: C.navy }}>
      {/* Header */}
      <div style={{
        padding: "18px 20px 14px", background: C.navyMid,
        borderBottom: `1px solid ${C.dim}`,
        display: "flex", alignItems: "center", gap: 12,
      }}>
        <button
          onClick={onBack}
          style={{
            background: "transparent", border: `1px solid ${C.dim}`,
            color: C.muted, borderRadius: 6, padding: "6px 12px",
            fontSize: 17, cursor: "pointer",
          }}
        >← Back</button>
        <div>
          <div style={{ fontSize: 11, color: C.muted, letterSpacing: 2 }}>FIND YOUR PATH</div>
          <div style={{ fontSize: 16, fontWeight: 800, color: C.white }}>Which Theme Fits You?</div>
        </div>
      </div>

      <div style={{ flex: 1, display: "flex", flexDirection: "column", justifyContent: "center", padding: 24 }}>
        {!result ? (
          <>
            {/* Progress */}
            <div style={{ display: "flex", gap: 6, marginBottom: 28, justifyContent: "center" }}>
              {quizQuestions.map((_, i) => (
                <div key={i} style={{
                  width: i === qIndex ? 28 : 10, height: 6, borderRadius: 3,
                  background: i < qIndex ? C.teal : i === qIndex ? C.pink : C.dim,
                  transition: "all 0.3s",
                }} />
              ))}
            </div>

            {/* Question */}
            <div style={{
              fontSize: 18, fontWeight: 700, color: C.white,
              textAlign: "center", marginBottom: 28, lineHeight: 1.4,
            }}>
              {quizQuestions[qIndex].question}
            </div>

            {/* Options */}
            <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
              {quizQuestions[qIndex].options.map((opt, i) => (
                <button
                  key={i}
                  onClick={() => handleAnswer(opt.path)}
                  style={{
                    padding: "16px 20px", background: C.card,
                    border: `1px solid ${C.dim}`, borderRadius: 10,
                    color: C.light, fontSize: 14, cursor: "pointer",
                    textAlign: "left", fontWeight: 500,
                    minHeight: 52, transition: "all 0.15s",
                  }}
                  onMouseEnter={e => {
                    const col = paths.find(p => p.id === opt.path)?.color || C.pink;
                    e.currentTarget.style.borderColor = col;
                    e.currentTarget.style.background = `${col}18`;
                  }}
                  onMouseLeave={e => {
                    e.currentTarget.style.borderColor = C.dim;
                    e.currentTarget.style.background = C.card;
                  }}
                >
                  {opt.label}
                </button>
              ))}
            </div>

            <div style={{ textAlign: "center", marginTop: 20, fontSize: 11, color: C.muted }}>
              Question {qIndex + 1} of {quizQuestions.length}
            </div>
          </>
        ) : (
          /* Result */
          <div style={{ textAlign: "center" }}>
            <div style={{ fontSize: 48, marginBottom: 12 }}>{resultPath.icon}</div>
            <div style={{ fontSize: 13, color: C.muted, letterSpacing: 2, marginBottom: 8 }}>
              YOUR RECOMMENDED PATH
            </div>
            <div style={{ fontSize: 26, fontWeight: 900, color: resultPath.color, marginBottom: 12 }}>
              {resultPath.label}
            </div>
            <div style={{
              background: C.card, borderRadius: 10, padding: 18,
              border: `1px solid ${resultPath.color}44`, marginBottom: 24,
              fontSize: 13, color: C.light, lineHeight: 1.6, textAlign: "left",
            }}>
              <div style={{ fontWeight: 700, color: resultPath.color, marginBottom: 6 }}>
                {resultPath.narrative}
              </div>
              {resultPath.desc}
            </div>

            <button
              onClick={() => onResult(result)}
              style={{
                width: "100%", padding: "15px 0", background: resultPath.color,
                color: C.white, border: "none", borderRadius: 8,
                fontWeight: 700, fontSize: 14, cursor: "pointer",
                marginBottom: 10, minHeight: 52,
              }}
            >
              USE THIS PATH →
            </button>
            <button
              onClick={onBack}
              style={{
                width: "100%", padding: "12px 0", background: "transparent",
                color: C.muted, border: `1px solid ${C.dim}`, borderRadius: 8,
                fontSize: 13, cursor: "pointer",
              }}
            >
              Choose a different path
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
